class DecorateHelper {
    static highLightControlTitle (title, titleRegExp, backgroundColor, textColor) {
        const searchText = title.match(new RegExp(titleRegExp, "i"));

        if (!searchText) return title;

        return title.replace(
            searchText[0],
            `<span style="background:${backgroundColor};color:${textColor};">${searchText[0]}</span>`
        )
    }

    static boldControlTitle (title) {
        return "<span style='font-weight:bold'>" + title + "</span>";
    }
}

export default DecorateHelper;